export default "__VITE_ASSET__DRSmHQL3__"